import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
	  userInfo:localStorage.getItem('userInfo') ? localStorage.getItem('userInfo') : null,
	  logoInfo:localStorage.getItem('logoInfo') ? localStorage.getItem('logoInfo') : null
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
